import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import FormInputWithLabel from '../../Components/Global_Components/form/FormInputWithLabel';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import CouplePatientInfo from '../../Components/Global_Components/common/CouplePatientInfo';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './booking_visit.scss';

export default function BookingVisit(props) {
  const [formData, setFormData] = useState({
    occupation: '',
    place: '',
    reference: '',
    obstetricScore: {g: '', p: '', l: '', a: '', e: ''},
    obstetricHistoryScore: {g: '', p: '', l: '', a: '', e: ''},
    lmp: '',
    pog: '',
    edd: '',
    modeOfConception: '',
    currentMedications: '',
    nausea: 'No',
    vomiting: 'No',
    bleeding: 'No',
    preconceptionalFolicAcid: 'No',
    injTT: '1 dose',
    picmeNumber: 'No',
    comorbidities: {
      gdm: {present: 'No', treatment: ''},
      pih: {present: 'No', treatment: ''},
      hypothyroidism: {present: 'No', treatment: ''},
      asthma: {present: 'No', treatment: ''}
    },
    menstrualLmp: '',
    menstrualCycles: 'Regular',
    pastMedicalHistory: '',
    surgicalHistory: [],
    familyHistory: {
      dm: {mother: 'No', father: 'No', siblings: 'No', others: 'No'},
      thyroid: {mother: 'No', father: 'No', siblings: 'No', others: 'No'},
      ht: {mother: 'No', father: 'No', siblings: 'No', others: 'No'},
      cancer: {mother: 'No', father: 'No', siblings: 'No', others: 'No'},
      twins: {mother: 'No', father: 'No', siblings: 'No', others: 'No'}
    },
    allergies: '',
    generalCondition: 'Fair',
    hydration: 'Adequate',
    bp: '',
    pr: '',
    spO2: '',
    weight: '',
    prePregnancyWeight: '',
    cvs: 'NAD',
    rs: 'NAD',
    uterusSize: '',
    fhr: '',
    nextAppointment: '',
    perAbdomen: ''
  });

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const modesOfConception = ['Spontaneous', 'IUI', 'ICSI'];
  const yesNoOptions = ['Yes', 'No'];
  const ttOptions = ['1 dose', '2 doses'];
  const cycleOptions = ['Regular', 'Irregular'];

  const [comorbiditiesRows, setComorbiditiesRows] = useState([
    {condition: 'GDM / Type 2 DM', treatment: ''},
    {condition: 'PIH / Hypertension', treatment: ''},
    {condition: 'Hypothyroidism', treatment: ''},
    {condition: 'Asthma', treatment: ''}
  ]);

  const comorbiditiesHeaders = [
    {key: 'condition', label: 'Condition', inputType: 'text'},
    {key: 'treatment', label: 'Treatment', inputType: 'select', options: ['Yes', 'No']}
  ];

  const [obstetricHistoryRows, setObstetricHistoryRows] = useState([
    {
      year: '',
      goutcome: '',
      modeOfConception: '',
      weeks: '',
      modeOfDelivery: '',
      babyOutcome: '',
      complications: '',
      comments: ''
    }
  ]);

  const obstetricHistoryHeaders = [
    {key: 'year', label: 'Year', inputType: 'text'},
    {key: 'goutcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Biochemical', 'Unidentified', 'Ectopic']},
    {key: 'modeOfConception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF']},
    {key: 'weeks', label: 'Weeks', inputType: 'text'},
    {key: 'modeOfDelivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Spontaneous', 'Medical Management', 'Surgical Management']},
    {key: 'babyOutcome', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Miscarriage', 'Others']},
    {key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']},
    {key: 'comments', label: 'COMMENTS', inputType: 'text'}
  ];

  const [medicalHistoryRows, setMedicalHistoryRows] = useState([{condition: '', duration: '', medications: '', others: ''}]);

  const medicalHistoryHeaders = [
    {key: 'condition', label: 'Condition', inputType: 'select', options: ['NIL', 'Diabetes', 'Hypertension', 'TB', 'Hypothyroidism', 'Hyperthyroidism', 'Others']},
    {key: 'duration', label: 'Duration', inputType: 'text'},
    {key: 'medications', label: 'Medications', inputType: 'text'},
    {key: 'others', label: 'Others', inputType: 'text'}
  ];

  const [surgicalHistoryRows, setSurgicalHistoryRows] = useState([{surgeryName: '', year: '', findings: ''}]);

  const surgicalHistoryHeaders = [
    {key: 'surgeryName', label: 'Surgery Name', inputType: 'text'},
    {key: 'year', label: 'Year', inputType: 'text'},
    {key: 'findings', label: 'Findings', inputType: 'text'}
  ];

  const [familyHistoryRows, setFamilyHistoryRows] = useState([{condition: '', mother: '', father: '', siblings: '', others: ''}]);

  const familyHistoryHeaders = [
    {
      key: 'condition',
      label: 'Condition',
      inputType: 'select',
      options: ['DM', 'Thyroid', 'HT', 'Cancer', 'Twins', 'Others', 'Nil']
    },
    {key: 'mother', label: 'Mother', inputType: 'text'},
    {key: 'father', label: 'Father', inputType: 'text'},
    {key: 'siblings', label: 'Siblings', inputType: 'text'},
    {key: 'others', label: 'Others', inputType: 'text'}
  ];

  const [investigationsRows, setInvestigationsRows] = useState([
    {investigation: 'Date', result: ''},
    {investigation: 'Blood Group', result: ''},
    {investigation: 'Hb/PCV/PLT', result: ''},
    {investigation: 'Urine RM, CS', result: ''},
    {investigation: 'Urea/Creat', result: ''},
    {investigation: 'TSH/FT4', result: ''},
    {investigation: 'GTT or FBS/HbA1C', result: ''},
    {investigation: 'HIV/HBsAg/HCV/VDRL', result: ''}
  ]);

  const investigationsHeaders = [
    {key: 'investigation', label: 'Investigation'},
    {key: 'result', label: 'Result'}
  ];

  const [scanInvestigationsRows, setScanInvestigationsRows] = useState([
    {date: '', scanType: 'Viability Scan', findings: ''},
    {date: '', scanType: 'NT Scan', findings: 'NT: ___ mm; NB: Seen / Absent'},
    {date: '', scanType: 'Combined Screen', findings: 'Trisomy 21/18/13 – Low / High Risk'},
    {date: '', scanType: 'NIPT', findings: 'Done / Not Done'},
    {date: '', scanType: 'Anomaly Scan', findings: ''},
    {date: '', scanType: 'Fetal Echo', findings: ''},
    {date: '', scanType: 'Growth Scan', findings: ''}
  ]);
  const scanInvestigationsHeaders = [
    {key: 'date', label: 'Date', inputType: 'date'},
    {key: 'scanType', label: 'Scan Type', inputType: 'text'},
    {key: 'findings', label: 'Findings', inputType: 'text'}
  ];

  const [medicationsRows, setMedicationsRows] = useState([
    {
      sno: '1',
      specificName: 'Folvista / Cor 3 / MecobMB',
      genericName: 'L-Methylfolate + Pyridoxine + Cyanocobalamin',
      dosage: '1 tab',
      frequency: '0-0-1',
      relationToFood: 'After food',
      idealTime: 'Night',
      duration: '30 days',
      purpose: 'Neural + hematinic support'
    },
    {
      sno: '2',
      specificName: 'Vomibune / Vomilast / Doxinate',
      genericName: 'Doxylamine + Pyridoxine',
      dosage: '1 tab',
      frequency: '1-0-1 (max 2/day)',
      relationToFood: 'Before food',
      idealTime: 'Morning & Night',
      duration: 'If vomiting',
      purpose: 'Anti-emetic'
    },
    {
      sno: '3',
      specificName: 'Evaraft',
      genericName: 'Calcium Carbonate + Sodium Alginate + Sodium Bicarbonate',
      dosage: '10 ml',
      frequency: 'BD/TDS',
      relationToFood: 'After food',
      idealTime: 'After meals & bedtime',
      duration: 'If needed',
      purpose: 'Reflux relief'
    },
    {
      sno: '4',
      specificName: 'Vivamom (Sugar free)',
      genericName: 'Protein supplement',
      dosage: '2 tsp',
      frequency: 'OD/BD',
      relationToFood: 'With milk',
      idealTime: 'Morning / Evening',
      duration: 'If needed',
      purpose: 'Nutritional support'
    },
    {
      sno: '5',
      specificName: 'Dydrofirst / Duphaston / Dydroboon',
      genericName: 'Dydrogesterone',
      dosage: '10 mg',
      frequency: 'TID',
      relationToFood: 'After food',
      idealTime: '8AM–2PM–8PM',
      duration: '30 days',
      purpose: 'Luteal support'
    },
    {
      sno: '6',
      specificName: 'Gufigest / Gestobond',
      genericName: 'Natural Micronised Progesterone',
      dosage: '400 mg',
      frequency: 'BD',
      relationToFood: 'Vaginal',
      idealTime: 'Morning & Night',
      duration: 'As advised',
      purpose: 'Luteal support + lie down 15 minutes'
    },
    {
      sno: '7',
      specificName: 'Thyronorm',
      genericName: 'Levothyroxine',
      dosage: 'As advised',
      frequency: 'OD',
      relationToFood: 'Empty stomach',
      idealTime: 'Early morning (6 AM)',
      duration: 'Ongoing',
      purpose: 'Thyroid control'
    },
    {
      sno: '8',
      specificName: 'Glycomet SR',
      genericName: 'Metformin SR',
      dosage: '500 mg',
      frequency: 'OD/BD',
      relationToFood: 'After food',
      idealTime: 'Dinner',
      duration: 'Ongoing',
      purpose: 'Insulin resistance'
    },
    {
      sno: '9',
      specificName: 'C-Vit / Celin',
      genericName: 'Vitamin C',
      dosage: '500 mg',
      frequency: '1-0-1',
      relationToFood: 'After food',
      idealTime: 'Morning',
      duration: '30 days',
      purpose: 'Hemoglobin improvement'
    },
    {
      sno: '10',
      specificName: 'Neuroplex / Neurobion',
      genericName: 'B-complex',
      dosage: '1 tab',
      frequency: 'OD',
      relationToFood: 'After food',
      idealTime: 'Morning',
      duration: '30 days',
      purpose: 'Hemoglobin improvement'
    },
    {
      sno: '11',
      specificName: 'Siracilt ointment',
      genericName: 'Topical',
      dosage: 'Local application',
      frequency: 'BD',
      relationToFood: 'Local',
      idealTime: 'Morning & Night',
      duration: 'If needed',
      purpose: 'Local care'
    }
  ]);

  const medicationsHeaders = [
    {key: 'sno', label: 'S. No', inputType: 'text'},
    {key: 'specificName', label: 'Brand Name', inputType: 'text'},
    {key: 'genericName', label: 'Generic Name', inputType: 'text'},
    {key: 'dosage', label: 'Dosage', inputType: 'text'},
    {key: 'frequency', label: 'Frequency', inputType: 'text'},
    {key: 'relationToFood', label: 'Relation to Food / Route', inputType: 'text'},
    {key: 'idealTime', label: 'Ideal Time', inputType: 'text'},
    {key: 'duration', label: 'Duration', inputType: 'text'},
    {key: 'purpose', label: 'Purpose', inputType: 'text'}
  ];

  useEffect(() => {
    if (formData.lmp) {
      const lmpDate = new Date(formData.lmp);
      
      // Calculate EDD: LMP + 280 days
      const eddDate = new Date(lmpDate);
      eddDate.setDate(lmpDate.getDate() + 280);
      const formattedEdd = eddDate.toISOString().split('T')[0];

      // Calculate POG: (Today - LMP) / 7 weeks
      const today = new Date();
      const diffTime = Math.abs(today - lmpDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const weeks = Math.floor(diffDays / 7);
      const days = diffDays % 7;
      const formattedPog = `${weeks}.${days}`;

      setFormData(prev => ({
        ...prev,
        edd: formattedEdd,
        pog: formattedPog
      }));
    }
  }, [formData.lmp]);

  useEffect(() => {
    console.log('formData -->', formData);
  }, [formData]);

  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };
  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };

  const renderIndentation = () => (
    <span
      style={{
        visibility: 'hidden',
        fontSize: '30px',
        lineHeight: '20px'
      }}>
      ●
    </span>
  );
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '30px',
        // lineHeight: "20px",
        display: 'flex',
        alignItems: 'center',
        height: '20px'
      }}>
      ●
    </span>
  );

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleObstetricScoreChange = (e, section) => {
    const {name, value} = e.target;
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value
      }
    }));
  };

  const [showTables, setShowTables] = useState({
    comorbiditiesInPregnancy: true,
    obstetricHistory: true,
    medicalHistory: true,
    surgicalHistory: true,
    familyHistory: true,
    investigations: true,
    scanInvestigations: true,
    medications: true
  });

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const handlesubmit = () => {
    props.loaderchange('false');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setShow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('bookingVisitReportWrap').innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              couple_id: formData.coupleId || props.patientsData?.couple_id || '',
              description: '',
              template_type: 'Booking Visit'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;
    return (
      <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
        <label style={{...styleLabel, fontWeight: '600', marginRight: '5px', width: 'max-content'}}>{name}</label>
        <span style={styleSpan}>{value}</span>
      </section>
    );
  };

  const formatScore = scoreObj => {
    return Object.entries(scoreObj)
      .map(([key, value]) => `${key.toUpperCase()}:${value || 0}`)
      .join(', ');
  };

  return (
    <div id='BookingVisit'>
      <div className='BookingVisit'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}
              alt='Header'
            />
          </div>
          <CouplePatientInfo
            patientsData={props.patientsData}
            show={show}
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            loaderchange={props.loaderchange}
          />
        </div>

        {/* Occupation Section */}
        <div className='detail mt-4'>
          <h3 className='row d-flex justify-content-center'>Booking Visit -- Antenatal Record</h3>

          <div className='row mt-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Occupation:' name='occupation' value={formData.occupation} onChange={handleChange} />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Place:' name='place' value={formData.place} onChange={handleChange} />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Reference :'
                name='refferedBy'
                value={formData.refferedBy}
                defaultValue={props.patientsData.doctor_id}
                required={false}
                onChange={handleChange}
                inputClassName='show'
              />
            </div>
          </div>
        </div>

        {/* Obstetric Status */}
        <div className='detail mt-4'>
          <h4>Chief Complaints & Obstetric Status</h4>

          <div className='row mt-3'>
            <div className='col-md-12'>
              <label className='me-2 fw-bold'>Obstetric Score:</label>
              {['g', 'p', 'l', 'a', 'e'].map(field => (
                <input
                  key={field}
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  name={field}
                  value={formData.obstetricScore[field]}
                  onChange={e => handleObstetricScoreChange(e, 'obstetricScore')}
                  style={{width: '40px', margin: '0 5px'}}
                  placeholder={field.toUpperCase()}
                />
              ))}
            </div>
          </div>

          {/*  <div className='row mt-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Obstetric Score:' name='obstetricScore' value={formData.obstetricScore} onChange={handleChange} minWidth='160px' />
            </div>
          </div> */}
          <div className='detail mt-4'>
            <h4>Menstrual History</h4>

            <div className='row'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='LMP:' name='lmp' value={formData.lmp} onChange={handleChange} type='date' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='POG: ' name='pog' value={formData.pog} onChange={handleChange} endLabel='weeks' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='EDD:' name='edd' value={formData.edd} onChange={handleChange} type='date' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3 mt-3 fw-bold'>
                <label className='me-2 fw-bold'>Cycles:</label>
                <select className={`createTime ${show ? 'hide' : 'show'}`} name='menstrualCycles' value={formData.menstrualCycles} onChange={handleChange}>
                  {cycleOptions.map(opt => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
                <label className='me-2 mt-3 fw-bold'>Mode of Conception:</label>
                <select className={`createTime ${show ? 'hide' : 'show'}`} name='modeOfConception' value={formData.modeOfConception} onChange={handleChange}>
                  <option value='' disabled>
                    Select
                  </option>
                  {modesOfConception.map(mode => (
                    <option key={mode} value={mode}>
                      {mode}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-md-5'>
                <ReportFormInputWithLabel label='Current Medications:' name='currentMedications' value={formData.currentMedications} onChange={handleChange} minWidth='200px' />
              </div>
            </div>
          </div>
        </div>

        {/* 1st Trimester Symptoms */}
        <div className='detail mt-4'>
          <h4>1st Trimester Symptoms</h4>

          <div className='row mt-3'>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Nausea:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='nausea' value={formData.nausea} onChange={handleChange}>
                {yesNoOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Vomiting:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='vomiting' value={formData.vomiting} onChange={handleChange}>
                {yesNoOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Bleeding/Spotting:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='bleeding' value={formData.bleeding} onChange={handleChange}>
                {yesNoOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className='row mt-3'>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Preconceptional Folic Acid:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='preconceptionalFolicAcid' value={formData.preconceptionalFolicAcid} onChange={handleChange}>
                {yesNoOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Inj TT Taken:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='injTT' value={formData.injTT} onChange={handleChange}>
                {ttOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>PICME Number:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='picmeNumber' value={formData.picmeNumber} onChange={handleChange}>
                {yesNoOptions.map(opt => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Comorbidities */}
        <div className='detail mt-4'>
          {showTables.comorbiditiesInPregnancy && (
            <TemplateTable
              id='comorbiditiesInPregnancy'
              title='Comorbidities IN PREGNANCY'
              headers={comorbiditiesHeaders}
              rows={comorbiditiesRows}
              onRowsChange={(id, newRows) => setComorbiditiesRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('comorbiditiesInPregnancy')}
            />
          )}
        </div>

        {/* Menstrual History */}

        <div className='detail mt-4'>
          <h4>Obstetric History</h4>

          {showTables.obstetricHistory && (
            <TemplateTable
              id='obstetricHistory'
              title=''
              headers={obstetricHistoryHeaders}
              rows={obstetricHistoryRows}
              onRowsChange={(id, newRows) => setObstetricHistoryRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('obstetricHistory')}
            />
          )}
        </div>

        <div className='row mt-3'>
          <div className='detail mt-4'>
            {showTables.medicalHistory && (
              <TemplateTable
                id='medicalHistory'
                title='Medical History'
                headers={medicalHistoryHeaders}
                rows={medicalHistoryRows}
                onRowsChange={(id, newRows) => setMedicalHistoryRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('medicalHistory')}
              />
            )}
          </div>

          <div className='detail mt-4'>
            {showTables.surgicalHistory && (
              <TemplateTable
                id='surgicalHistory'
                title='Surgical History'
                headers={surgicalHistoryHeaders}
                rows={surgicalHistoryRows}
                onRowsChange={(id, newRows) => setSurgicalHistoryRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('surgicalHistory')}
              />
            )}
          </div>

          <div className='detail mt-4'>
            {showTables.familyHistory && (
              <TemplateTable
                id='familyHistory'
                title='Family History'
                headers={familyHistoryHeaders}
                rows={familyHistoryRows}
                onRowsChange={(id, newRows) => setFamilyHistoryRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('familyHistory')}
              />
            )}
          </div>

          <div className='row'>
            <div className='col-md-6 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 fw-bold'>Allergies:</label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='allergies' value={formData.allergies} onChange={handleChange}>
                <option value='' disabled>
                  Select
                </option>
                {yesNoOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            {formData.allergies === 'Yes' && (
              <div className='col-md-6'>
                <ReportFormInputWithLabel label='Details' name='details' value={formData.details} onChange={handleChange} />
              </div>
            )}
          </div>

          <div className='detail mt-3'>
            <h4>On Examination</h4>
            <div className='row '>
              <div className='col-md-4'>
                <ReportFormInputWithLabel placeholder='Fair' label='General Condition:' name='generalCondition' value={formData.generalCondition} onChange={handleChange} minWidth='180px' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel placeholder='Adequate' label='Hydration:' name='hydration' value={formData.hydration} onChange={handleChange} />
              </div>
            </div>

            <div className='row '>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='BP :' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='PR :' name='pr' value={formData.pr} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='SpO2 :' name='spO2' value={formData.spO2} required={false} onChange={handleChange} inputClassName='show' endLabel='%' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Weight :' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel
                  label='Pre-pregnancy weight :'
                  name='prePregnancyWeight'
                  value={formData.prePregnancyWeight}
                  required={false}
                  onChange={handleChange}
                  inputClassName='show'
                  endLabel='kg'
                  minWidth='200px'
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='CVS :' name='cvs' value={formData.cvs} required={false} onChange={handleChange} />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='RS :' name='rs' value={formData.rs} required={false} onChange={handleChange} />
              </div>
            </div>

            <div className='row'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Per Abdomen :' name='perAbdomen' value={formData.perAbdomen} required={false} onChange={handleChange} minWidth='140px' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Uterus size :' name='uterusSize' value={formData.uterusSize} required={false} onChange={handleChange} />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='FHR :' name='fhr' value={formData.fhr} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
              </div>
            </div>
          </div>

          <div className='detail mt-4'>
            {showTables.investigations && (
              <TemplateTable
                id='investigations'
                title='Investigations'
                headers={investigationsHeaders}
                rows={investigationsRows}
                onRowsChange={(id, newRows) => setInvestigationsRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('investigations')}
              />
            )}
          </div>

          <div className='detail mt-4'>
            {showTables.scanInvestigations && (
              <TemplateTable
                id='scanInvestigations'
                title='Scans / Special Investigations'
                headers={scanInvestigationsHeaders}
                rows={scanInvestigationsRows}
                onRowsChange={(id, newRows) => setScanInvestigationsRows(newRows)}
                enableActions={true} // since scan types are fixed
                onNill={() => handleNill('scanInvestigations')}
              />
            )}
          </div>

          <div className='detail mt-4'>
            {showTables.medications && (
              <TemplateTable
                id='medications'
                title='Medications'
                headers={medicationsHeaders}
                rows={medicationsRows}
                onRowsChange={(id, newRows) => setMedicationsRows(newRows)}
                enableActions={true}
                onNill={() => handleNill('medications')}
              />
            )}
          </div>

          <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
            {/* <div className='detail mt-4'> */}
            <label htmlFor='advice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
              Advice:
            </label>
            <textarea className='Textarea' placeholder='advice...' id='advice' name='advice' onChange={handleChange} rows='4' cols='100' />
          </div>

          <p className='pt-3' style={{fontWeight: '600'}}>
            NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
          </p>
        </div>

        {/* Footer and Submit Button */}
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
        <div className=''>
          <ul className='list-unstyled'>
            <li>Investigations: AN Profile - Blood group, CBC, Urine RM & CS, TSH/FT4, Rubella IgG, HIV, HBsAg, VDRL, Anti HCV, Urea, Creatinine, LFT, GCT with 75g glucose.</li>
            <li>For additional reference and in-depth video explanations, you may visit</li>
            <li>🔴 Aishwarya’s official YouTube channel: www.youtube.com/@Doctormommies</li>
          </ul>
        </div>
      </div>

      {/* Report Generation Section */}
      <div id='generateBookingVisitReport'>
        <div id='bookingVisitReportWrap'>
          <Headers />
          <p class='Dani'></p>
          {/* Patient Information — same layout as FertilityFirstVisit */}
          <div
            className='firstPartner'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.coupleId ? formData.patientName1 : `${props.patientsData.titles || ''} ${props.patientsData.first_name || ''} ${props.patientsData.last_name || ''}`, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.coupleId ? formData.patientId1 : props.patientsData.p_uhid, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.coupleId ? formData.gender1 : props.patientsData.gender, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.coupleId ? formData.age1 : props.patientsData.age, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>
          {formData.coupleId && (
            <div className='secondPartner' style={{border: '1px solid black', borderRadius: '10px'}}>
              <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
                {renderReportfield('Patient Name :', formData.patientName2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Patient ID :', formData.patientId2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Gender :', formData.gender2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Age :', formData.age2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
              </div>
            </div>
          )}

          {/* Occupation Section */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>Booking Visit -- Antenatal Record</h4>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('Occupation:', formData.occupation)}
              {renderReportfield('Place:', formData.place)}
              {renderReportfield('Reference:', formData.refferedBy)}
            </div>
          </div>

          {/* Obstetric Status */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Chief Complaints & Obstetric Status</h5>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('Obstetric Score:', formatScore(formData.obstetricScore))}
              {renderReportfield('LMP:', formData.lmp)}
              {renderReportfield('POG:', `${formData.pog} weeks`)}
              {renderReportfield('EDD:', formData.edd)}
              {renderReportfield('Cycles:', formData.menstrualCycles)}
              {renderReportfield('Mode of Conception:', formData.modeOfConception)}
              {renderReportfield('Current Medications:', formData.currentMedications)}
            </div>
          </div>

          {/* 1st Trimester Symptoms */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>1st Trimester Symptoms</h5>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('Nausea:', formData.nausea)}
              {renderReportfield('Vomiting:', formData.vomiting)}
              {renderReportfield('Bleeding/Spotting:', formData.bleeding)}
              {renderReportfield('Preconceptional Folic Acid:', formData.preconceptionalFolicAcid)}
              {renderReportfield('Inj TT Taken:', formData.injTT)}
              {renderReportfield('PICME Number:', formData.picmeNumber)}
            </div>
          </div>

          {/* Comorbidities */}
          {showTables.comorbiditiesInPregnancy && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Comorbidities in Pregnancy</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Condition</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Treatment</th>
                  </tr>
                </thead>
                <tbody>
                  {comorbiditiesRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.condition}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.treatment}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Obstetric History */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Obstetric History</h5>

            {showTables.obstetricHistory && (
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Year</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>G Outcome</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Mode of Conception</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Weeks</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Mode of Delivery</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Baby Outcome</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Complications</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {obstetricHistoryRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.year}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.goutcome}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.modeOfConception}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.weeks}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.modeOfDelivery}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.babyOutcome}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.complications}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.comments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Medical History */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Medical History</h5>
          </div>

          {showTables.medicalHistory && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              {/* <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Surgical History</h5> */}
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Condition</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Duration</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Medications</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Others</th>
                  </tr>
                </thead>
                <tbody>
                  {medicalHistoryRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.condition}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.duration}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.medications}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.others}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Surgical History */}
          {showTables.surgicalHistory && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Surgical History</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Surgery Name</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Year</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Findings</th>
                  </tr>
                </thead>
                <tbody>
                  {surgicalHistoryRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.surgeryName}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.year}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.findings}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Family History */}
          {showTables.familyHistory && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Family History</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Condition</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Mother</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Father</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Siblings</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Others</th>
                  </tr>
                </thead>
                <tbody>
                  {familyHistoryRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.condition}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.mother}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.father}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.siblings}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.others}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Allergies */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Allergies</h5>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('Allergies:', formData.allergies)}
              {formData.allergies === 'Yes' && renderReportfield('Details:', formData.details)}
            </div>
          </div>

          {/* On Examination */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <h5 style={{fontWeight: 600, marginBottom: '15px'}}>On Examination</h5>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px'}}>
              {renderReportfield('General Condition:', formData.generalCondition)}
              {renderReportfield('Hydration:', formData.hydration)}
              {renderReportfield('BP:', `${formData.bp} mmHg`)}
              {renderReportfield('PR:', `${formData.pr} bpm`)}
              {renderReportfield('SpO2:', `${formData.spO2}%`)}
              {renderReportfield('Weight:', `${formData.weight} kg`)}
              {renderReportfield('Pre-pregnancy Weight:', `${formData.prePregnancyWeight} kg`)}
              {renderReportfield('CVS:', formData.cvs)}
              {renderReportfield('RS:', formData.rs)}
              {renderReportfield('Per Abdomen:', formData.perAbdomen)}
              {renderReportfield('Uterus Size:', formData.uterusSize)}
              {renderReportfield('FHR:', `${formData.fhr} bpm`)}
            </div>
          </div>

          {/* Investigations */}
          {showTables.investigations && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Investigations</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>{investigationsHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {investigationsRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.investigation)}
                      {renderTableTD(row.result)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Scans/Special Investigations */}
          {showTables.scanInvestigations && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Scans / Special Investigations</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Date</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Scan Type</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Findings</th>
                  </tr>
                </thead>
                <tbody>
                  {scanInvestigationsRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.date}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.scanType}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.findings}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Medications */}
          {showTables.medications && (
            <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Medications</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>S. No</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Brand Name</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Generic Name</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Dosage</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Frequency</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Relation to Food / Route</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Ideal Time</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Duration</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Purpose</th>
                  </tr>
                </thead>
                <tbody>
                  {medicationsRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px', textAlign: 'center'}}>{row.sno}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.specificName}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.genericName}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.dosage}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.frequency}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.relationToFood}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.idealTime}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.duration}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.purpose}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre>
          </div>

          {/* Next Appointment */}
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
            {/* <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Next Appointment</h5>
            <p>{formData.nextAppointment}</p> */}
          </div>

          {[
            'Investigations: AN Profile - Blood group, CBC, Urine RM & CS, TSH/FT4, Rubella IgG, HIV, HBsAg, VDRL, Anti HCV, Urea, Creatinine, LFT, GCT with 75g glucose.',
            'For additional reference and in-depth video explanations, you may visit',
            `🔴 Aishwarya's official YouTube channel: www.youtube.com/@Doctormommies `
          ].map((ele, ind) => {
            return (
              <div style={{display: 'flex', marginBottom: '10px'}}>
                {renderIndentation()}
                {renderDiscPoint()}
                {renderReportfield(ele, '', {styleSec: {width: '100%'}})}
              </div>
            );
          })}

          {/* Footer */}
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
